import React from "react";

import Entities from "../../components/Entities";

function Territories() {
  return (
    <Entities
      shema={{
        searchFromServer: true,
        searchRoute: "territories",
        fields: [
          { name: "Name", propertyName: "name", search: true },
          {
            name: "Province",
            propertyName: "province",
            isObject: true,
          },
        ],
      }}
    />
  );
}

export default Territories;
